import React from 'react';

import ViskaRedLogo from '../viska-red.png';
import ViskaRedLogoRetina from '../viska-red@2x.png';

import './Privacy.css';

export default () =>
  <div className="Privacy">
    <div className="Privacy__header">
      <a href="/">
        <img
          className="Privacy__header__logo"
          src={ViskaRedLogo}
          srcSet={`${ViskaRedLogoRetina} 2x`}
          alt="Viska"
        />
      </a>
    </div>
    <div className="Privacy__content">
      <div className="Privacy__content__message">
        <h1>Privacy Policy</h1>
        <p>Last updated: June 07, 2017</p>
        <p>
          Viska Learning ("us", "we", or "our") operates the Viska web and
          mobile application (the "Service").
        </p>
        <p>
          This page informs you of our policies regarding the collection, use
          and disclosure of Personal Information when you use our Service.
        </p>
        <p>
          We will not use or share your information with anyone except as
          described in this Privacy Policy.
        </p>
        <p>
          We use your Personal Information for providing and improving the
          Service. By using the Service, you agree to the collection and use of
          information in accordance with this policy. Unless otherwise defined
          in this Privacy Policy, terms used in this Privacy Policy have the
          same meanings as in our Terms and Conditions.
        </p>
        <h2>Information Collection And Use</h2>
        <p>
          While using our Service, we may ask you to provide us with certain
          personally identifiable information that can be used to contact or
          identify you. Personally identifiable information may include, but is
          not limited to, your email address, name, phone number, postal address
          ("Personal Information").
        </p>
        <h2>Log Data</h2>
        <p>
          When you access the Service by or through a mobile device, we may
          collect certain information automatically, including, but not limited
          to, the type of mobile device you use, your mobile device unique ID,
          the IP address of your mobile device, your mobile operating system,
          the type of mobile Internet browser you use and other statistics ("Log
          Data").
        </p>
        <p>
          In addition, we may use third party services such as Google Analytics
          that collect, monitor and analyze this type of information in order to
          increase our Service's functionality. These third party service
          providers have their own privacy policies addressing how they use such
          information.
        </p>
        <h2>Cookies</h2>
        <p>
          Cookies are files with small amount of data, which may include an
          anonymous unique identifier. Cookies are sent to your browser from a
          web site and stored on your computer's hard drive.
        </p>
        <p>
          We use "cookies" to collect information. You can instruct your browser
          to refuse all cookies or to indicate when a cookie is being sent.
          However, if you do not accept cookies, you may not be able to use some
          portions of our Service.
        </p>
        <h2>Service Providers</h2>
        <p>
          We may employ third party companies and individuals to facilitate our
          Service, to provide the Service on our behalf, to perform
          Service-related services or to assist us in analyzing how our Service
          is used.
        </p>
        <p>
          These third parties have access to your Personal Information only to
          perform these tasks on our behalf and are obligated not to disclose or
          use it for any other purpose.
        </p>
        <h2>Communications</h2>
        <p>
          We may use your Personal Information to contact you with newsletters,
          marketing or promotional materials and other information that may be
          of interest to you. You may opt out of receiving any, or all, of these
          communications from us by following the unsubscribe link or
          instructions provided in any email we send.
        </p>
        <h2>Compliance With Laws</h2>
        <p>
          We will disclose your Personal Information where required to do so by
          law or subpoena or if we believe that such action is necessary to
          comply with the law and the reasonable requests of law enforcement or
          to protect the security or integrity of our Service.
        </p>
        <h2>Business Transaction</h2>
        <p>
          If Viska Learning is involved in a merger, acquisition or asset sale,
          your Personal Information may be transferred. We will provide notice
          before your Personal Information is transferred and becomes subject to
          a different Privacy Policy.
        </p>
        <h2>Security</h2>
        <p>
          The security of your Personal Information is important to us, but
          remember that no method of transmission over the Internet, or method
          of electronic storage is 100% secure. While we strive to use
          commercially acceptable means to protect your Personal Information, we
          cannot guarantee its absolute security.
        </p>
        <h2>International Transfer</h2>
        <p>
          Your information, including Personal Information, may be transferred
          to — and maintained on — computers located outside of your state,
          province, country or other governmental jurisdiction where the data
          protection laws may differ than those from your jurisdiction.
        </p>
        <p>
          If you are located outside Iceland and choose to provide information
          to us, please note that we transfer the information, including
          Personal Information, to Iceland and process it there.
        </p>
        <p>
          Your consent to this Privacy Policy followed by your submission of
          such information represents your agreement to that transfer.
        </p>
        <h2>Links To Other Sites</h2>
        <p>
          Our Service may contain links to other sites that are not operated by
          us. If you click on a third party link, you will be directed to that
          third party's site. We strongly advise you to review the Privacy
          Policy of every site you visit.
        </p>
        <p>
          We have no control over, and assume no responsibility for the content,
          privacy policies or practices of any third party sites or services.
        </p>
        <h2>Children's Privacy</h2>
        <p>
          Our Service does not address anyone under the age of 13 ("Children").
        </p>
        <p>
          We do not knowingly collect personally identifiable information from
          children under 13. If you are a parent or guardian and you are aware
          that your Children has provided us with Personal Information, please
          contact us. If we become aware that we have collected Personal
          Information from a children under age 13 without verification of
          parental consent, we take steps to remove that information from our
          servers.
        </p>
        <h2>Changes To This Privacy Policy</h2>
        <p>
          We may update our Privacy Policy from time to time. We will notify you
          of any changes by posting the new Privacy Policy on this page.
        </p>
        <p>
          You are advised to review this Privacy Policy periodically for any
          changes. Changes to this Privacy Policy are effective when they are
          posted on this page.
        </p>
        <h2>Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact
          us, support@viskalearning.com.
        </p>

      </div>
    </div>
  </div>;



// WEBPACK FOOTER //
// ./src/pages/Privacy.js